import {
  GetExperiencesListResponseBodyType,
  GetOffersExperienceListResponseType,
} from "@intelligems/ig-types";
import { api } from "@src/api/api";
import { offerKeys } from "@src/api/queryKeys";
import { QueryOptions } from "@src/types/react-query";
import { useQuery } from "@tanstack/react-query";

const getOffersExperienceList =
  async (): Promise<GetOffersExperienceListResponseType> => {
    const resp = await api.get<GetOffersExperienceListResponseType>(
      `/v2/offers-experience-list`
    );
    return resp.data;
  };

export const useGetOffersExperienceList = (
  options?: QueryOptions<GetOffersExperienceListResponseType, Error>
) => {
  return useQuery<GetOffersExperienceListResponseType, Error>({
    ...options,
    queryKey: offerKeys.all,
    queryFn: async () => getOffersExperienceList(),
  });
};
